export function isLeaf(node) {
    return !node.children || node.children.length == 0;
}
//# sourceMappingURL=utils.js.map